<template>
  <app-admin>
    <div class="container content clearfix">
      <h1>Добавление нового участника</h1>
      <form @submit.prevent="save(false)" class="form form-sm">
        <div class="form-group">
          <label for="surname">Фамилия <sup>*</sup></label>
          <input type="text" id="surname" v-model="player.last_name" autofocus
                 v-validate="'required'" name="фамилия" data-vv-delay="500"
                 ref="firstInput">
          <p class="error" v-if="errors.has('фамилия')">{{ errors.first('фамилия') }}</p>
        </div>
        <div class="form-group">
          <label for="name">Имя <sup>*</sup></label>
          <input type="text" id="name" v-model="player.first_name"
                 v-validate="'required'" name="имя" data-vv-delay="500">
          <p class="error" v-if="errors.has('имя')">{{ errors.first('имя') }}</p>
        </div>
        <div class="form-group">
          <label for="patronymic">Отчество</label>
          <input type="text" id="patronymic"
                 v-model="player.middle_name">
        </div>
        <transition name="fade">
          <div class="hint" v-if="showHint">
            <font-awesome-icon icon="check"/>
            <span>Участник {{fio}} добавлен</span>
          </div>
        </transition>
        <div class="buttons-group-right">
          <router-link :to="{ name: 'Group' }">
            <div class="btn btn-light">Отмена</div>
          </router-link>
          <button type="button" @click="playerNull()" class="btn">Сохранить и добавить еще</button>
          <button class="btn" @click="save(true)" type="button">Сохранить</button>
        </div>
      </form>

    </div>
  </app-admin>
</template>

<script>
  import PlayersService from '@/services/PlayersService'
  import GroupsService from '@/services/GroupsService'

  export default {
    name: 'NewPlayer',
    data () {
      return {
        player: {
          last_name: '',
          first_name: '',
          middle_name: '',
          group_set: [this.group]
        },
        group: {
          name: '',
          theme: {
            name: ''
          }
        },
        playersInGroup: [],
        fio: '',
        showHint: false
      }
    },
    methods: {
      playerNull () {
        this.fio = `${this.player.last_name} ${this.player.first_name} ${this.player.middle_name}`

        this.$validator.validateAll().then((result) => {
          const state = this
          if (result) {
            PlayersService.createPlayer(state.player).then(
              (createdPlayer) => {
                state.showHint = true
                state.player.last_name = null
                state.player.first_name = null
                state.player.middle_name = ''

                const player = this.player
                PlayersService.getPlayer(createdPlayer.id).then(
                  (response) => {
                    if (player) {
                      PlayersService.addPlayerToGroup(state.group.id, createdPlayer.id).then(
                        (response) => {
                          state.playersInGroup.push(player)
                        }
                      )
                    }
                  })
              }
            )
          }
        })
      },
      save (goBack) {
        this.fio = `${this.player.last_name} ${this.player.first_name} ${this.player.middle_name}`

        this.$validator.validateAll().then((result) => {
          const state = this
          if (result) {
            PlayersService.createPlayer(state.player).then(
              (createdPlayer) => {
                state.showHint = true

                const player = this.player
                PlayersService.getPlayer(createdPlayer.id).then(
                  (response) => {
                    if (player) {
                      PlayersService.addPlayerToGroup(state.group.id, createdPlayer.id).then(
                        (response) => {
                          state.playersInGroup.push(player)

                          setTimeout(() => {
                            state.showHint = false
                            if (goBack) {
                              state.$router.push({name: 'Group'})
                            }
                          }, 1000)
                        }
                      )
                    }
                  })
              }
            )
          }
        })
      }
    },
    mounted () {
      let id = this.$route.params.id
      GroupsService.getGroup(id).then(
        (response) => {
          this.group = response
        }
      )

      PlayersService.getPlayersByGroupId(id).then(
        (response) => {
          this.playersInGroup = response
        },
        (error) => console.log(error)
      )
    }
  }
</script>

<style scoped lang="less">

</style>



// WEBPACK FOOTER //
// src/pages/admin/players/NewGroupPlayer.vue